import React, { useEffect, useState } from "react";
import Filters from "./filters";
import OnboardingCoachScorecardPatients from "./patients";
import { useFetch } from "hooks";
import { path } from "ramda";
import { put, post, get } from "../../../../../utils/api";
import { getApiErrorMessage } from "utils/misc";
import * as msg from "actions/message";
import { PureModal } from "components/ui";
import TableCoaches from "./table-coaches";
import { browserHistory } from "browser-history";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

const CoachScorecardTab = ({ companyId }) => {
  const dispatch = useDispatch();
  const [modalFilters, setModalFilters] = useState({});
  const [overallCoachesData, setOverallCoachesData] = useState([]);

  const [overallCoachesFilters, setOverallCoachesFilters] = useState({
    TeamId: "",
    CoachId: "",
    CompanyId: companyId,
    DateFrom: "",
    DateTo: "",
    DateType: "SetupDate"
  });

  const { fetchData, isFetching } = useFetch({
    apiFn: (payload) => put(`onboarding-dashboard/coach-scorecard`, payload),
    defaultValue: {},
    transformError: path(["response", "body", "status"]),
    onError: error => {
      dispatch(
        msg.errorMessage(
          `Failed to get onboarding coaches scorecard: ${getApiErrorMessage(
            error
          )}`
        )
      );
    }
  });

  const fetchCoachesData = async (payload) => {
    setOverallCoachesFilters({...overallCoachesFilters, ...payload});
  };

  useEffect(() => {
    fetchAll();
  }, [overallCoachesFilters]);

  const fetchAll = async () => {
    await fetchOverall(overallCoachesFilters);
  };

  const fetchOverall = async filters => {
    const overallPts = await fetchData(filters);
    setOverallCoachesData(overallPts);
  };

  const triggerModal = ({ type, coachId, origin }) => {
    setModalFilters({ ...overallCoachesFilters, type, coachId });
    document.getElementById(`chartItemClicked`).click();
  };

  useEffect(() => {
    browserHistory.replace(
      `${browserHistory.location.pathname}?tab=CoachScorecard`
    );
  }, []);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "5px",
          marginRight: "10px",
          borderBottom: "1px solid lightgrey"
        }}
      >
        <Filters
          fetchData={fetchCoachesData}
          isFetching={isFetching}
          companyId={companyId}
          initialFilters={overallCoachesFilters}
        />
      </div>
      <TableCoaches
        isFetching={isFetching}
        data={overallCoachesData}
        openModal={type => triggerModal(type)}
      />
      <PureModal
        windowProps={{ large: true, modalZIndex: 6, modalBehindModal: true }}
        renderTrigger={({ openModal }) => (
          <div id="chartItemClicked" onClick={openModal}></div>
        )}
        renderContent={({ closeModal }) => (
          <OnboardingCoachScorecardPatients
            filters={modalFilters}
            closeModal={closeModal}
          />
        )}
      />
    </div>
  );
};

CoachScorecardTab.propTypes = {
  companyId: PropTypes.string
};

export default CoachScorecardTab;
